import { html } from '../../utils/lit/html.js';

const template = (css = '') => {
  const e = document.createElement('template');
  e.innerHTML = html`
    <style id="widget-styles">
      :host {
        box-sizing: border-box;
        display: block;
        height: 100%;
        width: 100%;
      }

      :host * {
        border-box: inherit;
      }

      #root {
        height: inherit;
        width: inherit;
      }

      /* hide disclaimer if cx-module's body is empty, failed to load/fetch */
      :host #root:empty ~ slot[name='disclaimer'] {
        display: none;
      }
      ${css}
    </style>
    <div id="root"></div>
    <slot name="loading" hidden>Loading..</slot>
    <slot name="error" hidden></slot>
    <slot name="disclaimer" hidden></slot>
  `;
  return e;
};

export default template;
